module.exports = __webpack_public_path__ + "img/backspace-reverse-fill.62d30bed.svg";